import React from 'react';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';

interface PdfViewerModalProps {
    isOpen: boolean;
    toggle: () => void;
    pdfUrl: string;
}

const PdfViewerModal: React.FC<PdfViewerModalProps> = ({ isOpen, toggle, pdfUrl }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
            <ModalHeader toggle={toggle}>Vista Previa de Factura</ModalHeader>
            <ModalBody style={{ height: '80vh'}}>
                {pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        title="PDF Viewer"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                    />
                ) : (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <p>No hay URL de PDF disponible.</p>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default PdfViewerModal;
